import * as CL from '@design-system/component-library';
import { useState } from 'react';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { selectMsg, t } from '../../../common/i18n/index.js';
import { ContactDropdown } from '../../../common/react-hook-form/fields/index.js';
import { ReceiverTypes } from '../../../common/utils/billingAccountUtils.js';
import { GridColumn } from '../../BillingAccountDetails/components/GridColumn.js';
import type { ReceiverType } from '../../../common/utils/billingAccountUtils.js';
import type {
  BillingAccountDeliveryMethod,
  Contact,
  ContactHeader,
  ContactType,
} from '../../../generated/api/models.js';

export interface EmailDeliveryMethodFormValues {
  deliveryMethod: BillingAccountDeliveryMethod;
  billLanguage?: string;
  billReceiverType?: ContactType;
  additionalBillReceiverEmails: string[];
  billReceiverId?: string;
  billReceiverName?: string;
}
export const BillReceiverEdit = ({
  contacts,
  receiverSameAsContact,
}: {
  contacts: Contact[] | ContactHeader[];
  receiverSameAsContact: boolean;
}) => {
  const [receiver, setReceiver] = useState<ReceiverType>(
    receiverSameAsContact ? ReceiverTypes.SAME_AS_CONTACT : ReceiverTypes.OTHER
  );

  return (
    <>
      <CL.GridRow>
        <GridColumn className="of-billing-account-details form-column edit-left">
          <CL.RadioGroup value={receiver} onChange={v => setReceiver(v as ReceiverType)}>
            <CL.RadioV2 key="sameAsContact" label={t.ZCX7('Same as contact')} value={ReceiverTypes.SAME_AS_CONTACT} />
            <CL.RadioV2 value={ReceiverTypes.OTHER} key="other" label={t.C6WY('Other')} />
          </CL.RadioGroup>
        </GridColumn>
      </CL.GridRow>
      {receiver === ReceiverTypes.OTHER && (
        <CL.GridRow>
          <GridColumn className="of-billing-account-details form-column edit-left">
            <ContactDropdown
              className={dsClass.MARGIN_BOTTOM_2}
              canAddNewContacts
              contacts={contacts || []}
              name="billReceiverId"
              placeHolderText={t.QRYV(selectMsg)}
            />
            <div className={dsClass.DISPLAY_FLEX}>
              <CL.Icon icon="information" type="light" size="s" />
              <span className={`${dsClass.TEXT_SMALL} ${dsClass.MARGIN_LEFT_2}`}>
                {t.RJT5('Select a contact from the list or create a new one.')}
              </span>
            </div>
          </GridColumn>
        </CL.GridRow>
      )}
    </>
  );
};
